import { BUSCAR_RESERVA } from '../../actions/types'

const initialState = undefined;

export default function reducerReserva (state = null, action = initialState) {
  switch (action.type) {
    case BUSCAR_RESERVA: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
